<template>
  <main-layout>
    <template slot="title">
      首頁
    </template>

    <template slot="main">
      <el-row :gutter="20">
        <el-col
          :xs="{ span: 24, offset: 0 }"
          :sm="{ span: 24, offset: 0 }"
          :md="{ span: 20, offset: 2 }"
          :lg="{ span: 16, offset: 4 }"
          :xl="{ span: 12, offset: 6 }"
        >
          <div class="divider"></div>

          <Ads/>

          <div class="divider"></div>

          <Greetings/>

          <div class="divider"></div>

          <Magazines/>

          <div class="divider"></div>

          <SiteLinks/>

          <SocialMedia/>

          <div class="divider"></div>

          <Copyright/>
        </el-col>
      </el-row>
    </template>
  </main-layout>
</template>

<script>
import MainLayout from '@/components/layouts/MainLayout'
import Ads from '@/components/home/Ads'
import Greetings from '@/components/home/Greetings'
import Magazines from '@/components/home/Magazines'
import SiteLinks from '@/components/home/SiteLinks'
import SocialMedia from '@/components/home/SocialMedia'
import Copyright from '@/components/Copyright'

export default {
  name: 'home-home',
  components: {
    MainLayout,
    Ads,
    Greetings,
    Magazines,
    SiteLinks,
    SocialMedia,
    Copyright
  }
}
</script>
